import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { vehicleDriverType, vehiclesType } from '../../types';

const initialState: vehiclesType = {
    is_loading_vehicles: false,
    vehicles: [],
    vehicles_message: '',
    is_vehicle_deleted: false,
    vehicle_delete_message: '',
    on_vehicle_delete: false,
    is_vehicle_added: false,
    on_vehicle_add: false,
    is_updating_vehicle: false,
    vehicle_add_message: '',
    drivers: []
};

export const vehiclesSlice = createSlice({
    name: 'vehicles',
    initialState,
    reducers: {
        getVehiclesLoading: (state, action: PayloadAction<boolean>) => {
            return {
                ...state,
                is_loading_vehicles: action.payload
            };
        },
        vehicleLoadingMessage: (state, action: PayloadAction<string>) => {
            return {
                ...state,
                vehicles_message: action.payload
            };
        },
        addVehicleSuccess: (state, action: PayloadAction<object>) => {
            const { success, message }: any = action.payload;
            return {
                ...state,
                is_vehicle_added: success,
                vehicle_add_message: message
            };
        },
        addVehicleLoading: (state, action: PayloadAction<boolean>) => {
            return {
                ...state,
                on_vehicle_add: action.payload
            };
        },
        getVehiclesSuccess: (state, action: PayloadAction<Array<object>>) => {
            return {
                ...state,
                vehicles: action.payload
            };
        },
        vehicleDelete: (state, action: PayloadAction<object>) => {
            const { success, message }: any = action.payload;
            return {
                ...state,
                is_vehicle_deleted: success,
                vehicle_delete_message: message
            };
        },
        deleteVehicleLoading: (state, action: PayloadAction<boolean>) => {
            return {
                ...state,
                on_vehicle_delete: action.payload
            };
        },
        getDriversSuccess: (state, action: PayloadAction<Array<vehicleDriverType>>) => {
            return {
                ...state,
                drivers: action.payload
            };
        },
        onUpdatingVehicle: (state, action: PayloadAction<boolean>) => {
            return {
                ...state,
                is_updating_vehicle: action.payload,
            };
        },
    }
});

export const { getVehiclesLoading, getVehiclesSuccess, vehicleLoadingMessage, vehicleDelete, deleteVehicleLoading, addVehicleLoading, addVehicleSuccess, getDriversSuccess, onUpdatingVehicle } = vehiclesSlice.actions;

export default vehiclesSlice.reducer;